<div class="top-pan-3-pic ucon">
  <div [ngStyle]="parent.TopPanTextStyle()" class="top-pan-text">
    作業中　暫くお待ちください。
  </div>
</div>
<div class="top-pan-3"></div>
